import { isReservedId, parseInstant } from '../domain/index.js';
export const isObject = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
export const isId = (value) => typeof value === 'string' && value.length > 0 && !isReservedId(value);
export const isInstant = (value) => typeof value === 'string' && parseInstant(value).ok;
export const isCount = (value) => typeof value === 'number' && Number.isInteger(value) && value >= 1;
export const isNumber = (value) => typeof value === 'number' && Number.isFinite(value);
export const isOptional = (value, check) => value === undefined || check(value);
/** Thrown inside a decoder and turned into a typed error at its boundary. */
export class Refused extends Error {
    reason;
    constructor(reason) {
        super(reason);
        this.reason = reason;
    }
}
export const refuse = (reason) => {
    throw new Refused(reason);
};
export const expect = (ok, reason) => {
    if (!ok)
        refuse(reason);
};
/** An object whose keys are identifiers and whose values are finite numbers. */
export const isAmounts = (value) => isObject(value) && Object.entries(value).every(([key, v]) => isId(key) && isNumber(v));
//# sourceMappingURL=decode.js.map